// extracted by mini-css-extract-plugin
module.exports = {"monogram":"Monogram_monogram__9oxRc","highlight":"Monogram_highlight__Q9l22"};